import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const GdprPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 md:pt-44 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">{t('gdpr.title')}</h1>

        {/* Company Info */}
        <div className="bg-[#161616] border border-[#2a2a2a] rounded-xl p-6 mb-8">
          <h2 className="text-xl font-semibold text-white mb-4">{t('gdpr.controllerTitle')}</h2>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">{t('gdpr.companyName')}:</span>
              <p className="text-gray-300">FBS group, s. r. o.</p>
            </div>
            <div>
              <span className="text-gray-500">{t('gdpr.regSeat')}:</span>
              <p className="text-gray-300">Tatranská Lomnica 14649, 059 60 Vysoké Tatry</p>
            </div>
            <div>
              <span className="text-gray-500">IČO:</span>
              <p className="text-gray-300">44898487</p>
            </div>
            <div>
              <span className="text-gray-500">DIČ:</span>
              <p className="text-gray-300">2022869717</p>
            </div>
            <div>
              <span className="text-gray-500">IČ DPH:</span>
              <p className="text-gray-300">SK2022869717</p>
            </div>
            <div>
              <span className="text-gray-500">{t('gdpr.established')}:</span>
              <p className="text-gray-300">18. 08. 2009</p>
            </div>
          </div>
        </div>

        {/* GDPR Sections */}
        <div className="space-y-8 text-gray-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section1Title')}</h2>
            <p>{t('gdpr.section1Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section2Title')}</h2>
            <p>{t('gdpr.section2Text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>{t('gdpr.section2item1')}</li>
              <li>{t('gdpr.section2item2')}</li>
              <li>{t('gdpr.section2item3')}</li>
              <li>{t('gdpr.section2item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section3Title')}</h2>
            <p>{t('gdpr.section3Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section4Title')}</h2>
            <p>{t('gdpr.section4Text')}</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-gray-400">
              <li>{t('gdpr.section4item1')}</li>
              <li>{t('gdpr.section4item2')}</li>
              <li>{t('gdpr.section4item3')}</li>
              <li>{t('gdpr.section4item4')}</li>
              <li>{t('gdpr.section4item5')}</li>
              <li>{t('gdpr.section4item6')}</li>
              <li>{t('gdpr.section4item7')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section5Title')}</h2>
            <p>{t('gdpr.section5Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('gdpr.section6Title')}</h2>
            <p>{t('gdpr.section6Text')}</p>
            <p className="mt-2 text-gray-400">{t('gdpr.section6contact')}</p>
          </section>

          <div className="border-t border-[#2a2a2a] pt-6 text-gray-500 text-xs">
            {t('gdpr.lastUpdated')}: 13.03.2026
          </div>
        </div>
      </div>
    </div>
  );
};

export default GdprPage;
